import { useMemo } from "react";

import { Form, FormikForm } from "@skilitics/designer-ui-components";
import type { NumberOperator } from "@skilitics/judy";

import type { NumberComparisonFormatStrings } from "../../../values/forms/comparison-views/index.ts";
import { NumberComparisonView, numberComparisonFormatStrings } from "../../../values/forms/comparison-views/index.ts";
import type { NumericValueConfig } from "../specifiers/NumericConditionSpecifier.tsx";

export type NumberConditionFormValues = {
  value: NumericValueConfig;
  value2: NumericValueConfig;
  operator: "" | NumberOperator;
};

export interface NumberConditionFormProps {
  disabled?: boolean;
  initialValues: NumberConditionFormValues;
  onSubmit: (values: NumberConditionFormValues) => void;
  min?: number;
  max?: number;
  formatStringOverrides?: Partial<NumberComparisonFormatStrings>;
}

export const NumberConditionForm = ({
  disabled = false,
  initialValues,
  onSubmit,
  min,
  max,
  formatStringOverrides,
}: NumberConditionFormProps) => {
  const mergedFormatStrings = useMemo(
    () => ({ ...numberComparisonFormatStrings, ...formatStringOverrides }),
    [formatStringOverrides],
  );

  return (
    <FormikForm<NumberConditionFormValues>
      initialValues={initialValues}
      onSubmit={onSubmit}
      submitOnBlur
      explicitLabels
      formatStrings={mergedFormatStrings}
      dataTest="number-condition-form"
    >
      <Form $labelAlignment="inline">
        <NumberComparisonView {...{ disabled, min, max, formatStringOverrides }} />
      </Form>
    </FormikForm>
  );
};

export type NumberConditionFormFormatStrings = NumberComparisonFormatStrings;
